import { MapPin, Phone, Clock } from "lucide-react";
import { CONTACT, LOGO_URL, TAGLINE } from "@/data";
import { useScrollTo } from "@/lib/smooth-scroll";

export const Footer = () => {
  const scrollTo = useScrollTo();
  return (
    <footer id="contact" data-testid="footer-section" className="relative bg-[var(--bg-0)] border-t border-white/10 pt-20">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col items-start gap-3 pb-14">
          <img src={LOGO_URL} alt="Speed Auto Lavage" className="h-20 sm:h-24 w-auto object-contain mix-blend-screen" />
          <p className="font-display italic font-light text-lg text-[var(--txt-1)]">{TAGLINE}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-16">
          <a href={`https://maps.google.com/?q=${encodeURIComponent(CONTACT.address)}`} target="_blank" rel="noreferrer" data-testid="footer-address" className="group flex items-start gap-4">
            <MapPin size={20} className="text-[var(--blue)] mt-1 shrink-0" />
            <div>
              <span className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-[var(--txt-2)]">Adresse</span>
              <p className="mt-1 text-white group-hover:text-[var(--blue)] transition-colors">{CONTACT.address}</p>
            </div>
          </a>
          <a href={`tel:${CONTACT.phoneRaw}`} data-testid="footer-phone" className="group flex items-start gap-4">
            <Phone size={20} className="text-[var(--blue)] mt-1 shrink-0" />
            <div>
              <span className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-[var(--txt-2)]">Téléphone</span>
              <p className="mt-1 text-white group-hover:text-[var(--blue)] transition-colors">{CONTACT.phone}</p>
            </div>
          </a>
          <div className="flex items-start gap-4" data-testid="footer-hours">
            <Clock size={20} className="text-[var(--blue)] mt-1 shrink-0" />
            <div>
              <span className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-[var(--txt-2)]">Horaires</span>
              <p className="mt-1 text-white">{CONTACT.hours}</p>
            </div>
          </div>
        </div>

        <button
          onClick={() => scrollTo("#reservation")}
          data-testid="footer-cta"
          className="w-full text-left"
        >
          <span className="block font-display font-extrabold uppercase tracking-tighter text-white leading-[0.85] text-[13vw] hover:text-[var(--blue)] transition-colors duration-500">
            Speed Auto
          </span>
        </button>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/10 py-8">
          <p className="font-mono2 text-[11px] uppercase tracking-[0.15em] text-[var(--txt-2)]">
            © {new Date().getFullYear()} Speed Auto Lavage · Marseille
          </p>
          <p className="font-mono2 text-[11px] uppercase tracking-[0.15em] text-[var(--txt-2)]">
            Lavage · Detailing · Protection céramique
          </p>
        </div>
      </div>
    </footer>
  );
};
